<div class="flex flex-col gap-3">
  <shared-search-type
    [formGroup]="formGroup"
    [pageType]="pageType"
    [resolvedPageType]="resolvedPageType()"
    [showRoroForComponent]="showRoroForComponent()"
    (containerTypeChange)="onContainerTypeChange($event)">
  </shared-search-type>

  @if (isTrailer()) {
    <shared-search-trailer
      [formGroup]="formGroup"
      [context]="childContext()"
      (buttonClick)="onButtonClick($event)"
      (containerClearRequest)="onContainerClearRequest()">
    </shared-search-trailer>
  } @else if (isMiscellaneous()) {
    <shared-search-miscellaneous
      [formGroup]="formGroup"
      [context]="childContext()"
      (buttonClick)="onButtonClick($event)"
      (containerClearRequest)="onContainerClearRequest()">
    </shared-search-miscellaneous>
  } @else if (isCasette()) {
    <shared-search-casette
      [formGroup]="formGroup"
      [context]="childContext()">
    </shared-search-casette>
  } @else {
    <shared-search-container
      [formGroup]="formGroup"
      [context]="childContext()"
      (buttonClick)="onButtonClick($event)"
      (containerClearRequest)="onContainerClearRequest()">
    </shared-search-container>
  }
</div>
